var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.label)?_c('base-label',_vm._b({attrs:{"prepend-icon":"mdi-cancel"}},'base-label',_vm.$attrs,false),[_vm._v(_vm._s(_vm.closed))]):_c('v-tooltip',{attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('v-icon',_vm._g(_vm._b({},'v-icon',attrs,false),on),[_vm._v("mdi-cancel")])]}}])},[_c('base-markdown',{staticClass:"text-caption",attrs:{"body":_vm.description}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }